<template>
  <div class="compute" v-if="locale.newcompute">
    <template v-if="loadingState">
      <div class="spinner">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 200 117" style="enable-background:new 0 0 200 117;" xml:space="preserve">
            <g id="triangle8">
                <path class="st0" d="M153,60.4l-22,10.9l22-31.4V60.4z"/>
            </g>
            <g id="triangle7">
                <path class="st1" d="M131,71.2l-24.4-25l46.4-6.5L131,71.2z"/>
            </g>
            <g id="triangle6">
                <path class="st2" d="M131,71.2L111.1,90l-4.5-43.8L131,71.2z"/>
            </g>
            <g id="triangle5">
                <path class="st0" d="M109.6,76.1l-2.2-21.5l0.3,21.4L109.6,76.1z"/>
            </g>
            <g id="triangle4">
                <path class="st1" d="M106.6,46.2l0.8,8.3l0.3,21.4l-23.2-1.5L106.6,46.2z"/>
            </g>
            <g id="triangle3">
                <path class="st3" d="M84.5,74.5L59.6,51l47-4.7L84.5,74.5z"/>
            </g>
            <g id="triangle2">
                <polygon class="st0" points="50.5,52 37.9,30.5 69.7,60.4"/>
            </g>
            <g id="triangle1">
                <path class="st2" d="M50.5,52l-12,18.3L59.6,56L50.5,52z"/>
            </g>
        </svg>
      </div>
    </template>
    <template v-if="!loadingState">
      <div class="content-headline">
        <div class="content-headline__wrapper">
          <h1>{{locale.newcompute.newcompute}}</h1>
        </div>
      </div>
      <form @submit.prevent="submit">
      <div class="form-group"> <!-- Message input !-->
        <errorMessages v-for="error in errors.all()" v-bind:key="error.id" v-bind:error="error"/>
        <div>
          <tabs>
            <tab :name="locale.newcompute.chooseImage">
              <div class="grid">
                <template v-for="image in images">
                  <div :key="image.id" class="grid__column grid__column--xs-6 grid__column--sm-4 grid__column--md-3 grid__column--lg-2">
                    <div class="compute-image">
                      <label class="compute-image__radio-label">
                        <input type="radio" name="image" class="compute-image__radio" v-model="form.image" v-bind:value="image.id"  v-on:click="clear('snapshot')"/>
                        <span class="compute-image__overlay"></span>
                        <span class="compute-image__image">
                          <img :src="'/static/img/'+ image.name + '-logo.png'" onerror="this.onerror=null;this.src='/static/img/mobi-default-transparent.png';">
                        </span>
                        <span class="compute-image__title">
                          {{image.name}}
                        </span>
                      </label>
                    </div>
                  </div>
                </template>
              </div>
            </tab>
            <tab :name="locale.newcompute.restoreSnapshot">
              <template v-for="snapshot in snapshots">
                <div :key="snapshot.id" class="snapshot">
                  <label class="snapshot__label">
                    <input type="radio" name="image" class="snapshot__radio" v-model="form.snapshot" v-bind:value="snapshot.id" v-on:click="clear('image')"/>
                    <span class="snapshot__overlay"></span>
                    <span class="snapshot__title">{{snapshot.name}}</span>
                  </label>
                </div>
              </template>
            </tab>
          </tabs>
        </div>
        <div class="choose-size">
          <h4>{{locale.newcompute.chooseSize}}</h4>
        </div>
        <div class="grid">
          <div class="grid__column grid__column--xs-12">
            <div class="flavor">
              <ul class="flavor__header-list">
                <li class="flavor__header-list-item">Pricing</li>
                <li class="flavor__header-list-item">Name</li>
                <li class="flavor__header-list-item">Memory</li>
                <li class="flavor__header-list-item">vCPUs</li>
                <li class="flavor__header-list-item">Transfer</li>
              </ul>
            </div>
          </div>

          <template v-for="flavor in bookableFlavors">
            <label :key="flavor.id" class="flavor__option">
              <input type="radio" name="flavor" v-model="form.flavor" class="flavor__radio" v-bind:value="flavor.id" />
              <ul class="flavor__option-list">
                <li class="flavor__option-list-item">
                  <span class="flavor__option-label">Pricing:</span>
                  <span class="flavor__option-title"><sup>€ </sup><span v-html="getPricePerMonth(prices[flavor.id])"></span><sub>/ {{locale.newcompute.month}}</sub></span>
                </li>
                <li class="flavor__option-list-item">
                  <span class="flavor__option-label">{{locale.newcompute.flavor.name}}:</span>
                  <span class="flavor__option-title">{{flavor.name}}</span>
                </li>
                <li class="flavor__option-list-item">
                  <span class="flavor__option-label">{{locale.newcompute.flavor.memory}}:</span>
                  <span class="flavor__option-title">{{flavor.ram}} MB</span>
                </li>
                <li class="flavor__option-list-item">
                  <span class="flavor__option-label">{{locale.newcompute.flavor.vcpus}}:</span>
                  <span class="flavor__option-title">{{flavor.cpu}} vCPU</span>
                </li>
                <li class="flavor__option-list-item">
                  <span class="flavor__option-label">{{locale.newcompute.flavor.transfer}}:</span>
                  <span class="flavor__option-title">1 TB</span>
                </li>
              </ul>
            </label>
          </template>
        </div>

        <div class="grid">
          <div class="grid__column grid__column--xs-12 grid__column--sm-12">
            <h4 class="control-label choose-host-name">Festplatten Typ</h4>
            <label class="radio-label">
              <input type="radio" v-model="form.type" value="ssd"/>
              SSD
            </label>
            <label class="radio-label">
              <input type="radio" v-model="form.type" value="hdd"/>
              HDD
            </label>
          </div>
          <div class="grid__column grid__column--xs-12 grid__column--sm-12">
            <h4 class="control-label choose-host-name">{{locale.newcompute.disksize}}</h4>
            <vue-slider v-model="form.size"  :marks="[10, 500, 1000, 1500, 2000]" :interval="10" :min=10 :max=2000 :tooltip="'always'" :tooltip-formatter="formatter1" :tooltip-placement="'bottom'"></vue-slider>
          </div>
          <div class="grid__column grid__column--xs-12 grid__column--sm-12">
            <h4 class="control-label choose-host-name">{{locale.newcompute.chooseHost}}</h4>
            <input type="text" class="form-control hostname" id="name" v-model="form.name" name="name" :placeholder="locale.newcompute.placeholder.webserver" v-validate="{ required: true, regex: /^[a-zA-Z0-9_ -]*$/ }">
          </div>
          <div class="grid__column grid__column--xs-12 grid__column--sm-12">
            <h4 class="add-ssh-key">{{locale.newcompute.addSSH}}</h4>
            <div class="keypair">
            <router-link to="/app/keypairs/new">
              <button class="button button--with-border button--no-margin">{{locale.newcompute.newSSH}}</button>
            </router-link>
              <template v-for="keypair in keypairs">
                <label :key="keypair.name" class="ssh-key">
                  <input type="radio" name="region" class="keypair" v-model="form.keypair" v-bind:value="keypair.name"/>
                  <span class="overlay-input-ssh-key"></span>
                  {{keypair.name}}
                </label>
              </template>
            </div>
          </div>
          <div class="grid__column grid__column--xs-12 grid__column--sm-12" v-if="totalPrice">
            <h4>{{locale.newcompute.monthlyCost}}<span class="hidden-md hidden-lg">: {{totalPrice}} €</span></h4>
            <div class="table-responsive compute-cost">
              <table class="responsive">
                <thead>
                  <tr>
                    <th scope="col">{{locale.newcompute.service}}</th>
                    <th scope="col">{{locale.newcompute.price}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td :data-label="locale.newcompute.service">{{locale.newcompute.server}}</td>
                    <td :data-label="locale.newcompute.price">{{computePrice}} €</td>
                  </tr>
                  <tr>
                    <td :data-label="locale.newcompute.service">{{locale.newcompute.disk}}</td>
                    <td :data-label="locale.newcompute.price">{{volumePrice}} €</td>
                  </tr>
                  <tr class="hidden-xs hidden-sm">
                    <td :data-label="locale.newcompute.service"><b>{{locale.newcompute.total}}</b></td>
                    <td :data-label="locale.newcompute.price"><b>{{totalPrice}} €</b></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group"> <!-- Submit button !-->
        <button class="button" name="submit" type="submit">{{locale.newcompute.buttonText}}</button>
      </div>
    </form>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import errorMessages from '../utils/errorMessages.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  name: 'NewCompute',
  components: {
    errorMessages,
    VueSlider
  },
  computed: {
    ...mapState(['locale']),
    ...mapState({
      flavors: state => state.flavors.flavors,
      images: state => state.images.images,
      snapshots: state => state.snapshots.snapshots,
      keypairs: state => state.keypairs.keypairs,
      loadingState: state => state.loadingState,
      prices: state => state.billing.prices
    }),
    volumePrice: function () {
      if (this.form.type === 'ssd') {
        return this.getPricePerMonth(this.prices['VolumeSSD'], this.form.size)
      }
      if (this.form.type === 'hdd') {
        return this.getPricePerMonth(this.prices['VolumeHDD'], this.form.size)
      }
    },
    computePrice: function () {
      return this.getPricePerMonth(this.prices[this.form.flavor])
    },
    totalPrice: function () {
      return Math.round((this.volumePrice + this.computePrice) * 100) / 100
    },
    bookableFlavors: function () {
      let bookable = []
      for (let key in this.flavors) {
        let obj = this.flavors[key]
        if (obj.bookable === true) {
          bookable.push(obj)
        }
      }
      return bookable
    }
  },
  data: function () {
    return {
      buttonText: 'Create',
      formatter1: '{value} GB',
      form: {
        name: '',
        image: '',
        snapshot: '',
        flavor: '',
        keypair: '',
        size: 10,
        type: ''
      }
    }
  },
  mounted () {
    this.$store.dispatch('keypairs/getKeypairs')
    this.$store.dispatch('billing/getPrices')
  },
  methods: {
    submit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.buttonText = 'Loading'
          if (this.form.image) {
            this.$store.dispatch('computes/createCompute', this.form).then(() => {
              this.$router.push({name: 'Compute'})
            })
          } else if (this.form.snapshot) {
            this.$store.dispatch('snapshots/restoreSnapshot', this.form).then(() => {
              this.$router.push({name: 'Compute'})
            })
          }
        }
      })
    },
    clear (field) {
      this.form[field] = ''
    },
    getPricePerMonth (object, multiplier) {
      if (!object) return
      if (!multiplier) multiplier = 1
      let pricePerMonth = (object.price * 60 * 24 * 30) * multiplier
      return Math.round(pricePerMonth * 100) / 100
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewCompute.vue